import { render, staticRenderFns } from "./PaymentIfastApiReturnToOnManualProcessingModal.vue?vue&type=template&id=18b6dc9c"
import script from "./PaymentIfastApiReturnToOnManualProcessingModal.vue?vue&type=script&lang=js"
export * from "./PaymentIfastApiReturnToOnManualProcessingModal.vue?vue&type=script&lang=js"
import style0 from "./PaymentIfastApiReturnToOnManualProcessingModal.vue?vue&type=style&index=0&id=18b6dc9c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports